import {
  RACK_SECTION_TYPE,
  TypePartialRackItem,
} from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/Rack.props";

export interface IAvailableRackItem {
  pos: RACK_SECTION_TYPE;
}
export interface IAvailableRack {
  readonly rack_type: [number, number];
  readonly id: string;
  readonly rack_items: IAvailableRackItem[];
}

export enum ActionTypesAvailableRacks {
  SET_AVAILABLE_RACKS = "SET_AVAILABLE_RACKS",
  DELETE_AVAILABLE_RACK = "DELETE_AVAILABLE_RACK",
  EDIT_AVAILABLE_RACK = "EDIT_AVAILABLE_RACK",
  ADD_AVAILABLE_RACK = "ADD_AVAILABLE_RACK",
}

export interface ActionBaseAvailableRack {
  readonly type: ActionTypesAvailableRacks;
}

export interface ActionSetAvailableRacks extends ActionBaseAvailableRack {
  readonly payload: IAvailableRack[];
}

export interface ActionDeleteAvailableRack extends ActionBaseAvailableRack {
  readonly payload: string;
}

export interface ActionEditAvailableRack extends ActionBaseAvailableRack {
  readonly payload: IAvailableRack;
}

export interface ActionAddAvailableRack extends ActionBaseAvailableRack {
  readonly payload: IAvailableRack;
}
